/* src/app/ship/ship-commodity/commodity-table/commodity-table.component.scss */
.commodity-table .mat-column-Weight,
.commodity-table .mat-column-CustomsValue {
  text-align: right;
}
.commodity-table .mat-mdc-row:last-of-type {
  font-weight: 700;
}
.commodity-table .mat-mdc-header-cell.mat-column-Quantity {
  width: 4.5em;
  text-align: center;
}
.commodity-table .mat-mdc-header-cell.mat-column-Weight {
  width: 4em;
}
.commodity-table .mat-mdc-header-cell.mat-column-CustomsValue {
  width: 8em;
}
.commodity-table .mat-mdc-cell {
  font-size: 0.9em;
}
.commodity-table .mat-mdc-cell.mat-column-Quantity {
  text-align: center;
}
.commodity-table .row-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.commodity-table .row-actions .mat-mdc-button {
  margin-left: 1em;
  min-width: initial;
  padding: 0;
  width: 2.5em;
  height: 2.5em;
  border-radius: 50%;
}
/*# sourceMappingURL=commodity-table.component.css.map */
